export async function fetchData() {
  try {
    const data = await import('../data/victim_data_2023.json');
    return data.default;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
}
